const e = {
  SMALL: "1rem",
  MEDIUM: "2rem",
  LARGE: "2rem"
}, r = {
  SMALL: "1rem",
  MEDIUM: "2rem",
  LARGE: "4rem"
};
export {
  e as GRID_GUTTER,
  r as GRID_PADDING
};
